import { useResponsive } from 'app/hooks';
import { Button, SVG } from 'app/pages/request-single-page/components-v4';
import { Icons } from 'app/pages/request-single-page/components-v4/icons';

export const ResetReadingsButton = ({ onClick }: { onClick?: () => void }) => {
  const { viewport } = useResponsive();

  if (viewport.mobile) {
    return (
      <Button
        iconButton={<SVG src={Icons.ArrowReturnLeft} />}
        mode="accent"
        variant="ghost"
        onClick={onClick}
      />
    );
  }

  return (
    <Button mode="accent" variant="ghost" onClick={onClick}>
      Очистить
    </Button>
  );
};
